<template>
  <div>
    <span
        @click="hitStarBtn"
      :class="[ `has-text-${isStarred(event) ? 'warning' : 'grey'}`, `is-${starColor !== 'transparent' ? 'normal' : 'medium'}` ]"
      class="icon is-rounded"
      style="transform: translateY(-4px)"
      :style="{backgroundColor: starColor}"
    >
      <i class="mdi mdi-24px" :class="`mdi-star${isStarred(event) ? '' : '-outline'}`"></i>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    event: {
        type: Object,
        required: true
    },
    starColor: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
      ...mapGetters({
          favoriteItemsList: 'appData/getFavoriteItemsList'
      })
  },
  methods: {
    isStarred() {
      return this.favoriteItemsList.includes(this.event.id);
    },
    hitStarBtn() {
        console.log('hit star button');
      this.$store.dispatch("appData/addToFavoriteItems", this.event);
    }
  }
};
</script>

<style>
</style>